import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import "./AdminRewardPage.css";

function AdminRewardPage() {

  const [blogs, setBlogs] = useState([]);
  const [rewards, setRewards] = useState([]);

  // ✅ pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 5;

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://success-blog-app-backend.onrender.com";

  const token = localStorage.getItem("token");

  const api = axios.create({
    baseURL: BASE_URL,
    headers: { Authorization: `Bearer ${token}` },
  });

  // fetch blogs
  const fetchBlogs = async () => {
    try {
      const res = await api.get("/api/admin/blogs");
      setBlogs(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // fetch rewards
  const fetchRewards = async () => {
    try {
      const res = await api.get("/api/reward");
      setRewards(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // add reward
  const addReward = async (blogId) => {
    const amount = prompt("Enter reward amount");

    if (!amount) return;

    try {
      await api.post("/api/reward/add", {
        blogId,
        amount: parseInt(amount),
      });

      fetchRewards();

    } catch (err) {
      console.log(err);
    }
  };

  // delete reward
  const deleteReward = async (rewardId) => {
    if (!window.confirm("Delete reward?")) return;

    try {
      await api.delete(`/api/reward/delete/${rewardId}`);
      fetchRewards();
    } catch (err) {
      console.log(err);
    }
  };

  // total reward
  const getBlogReward = (blogId) => {
    const blogRewards = rewards.filter((r) => r.blogId === blogId);
    if (blogRewards.length === 0) return 0;
    return blogRewards.reduce((sum, r) => sum + r.amount, 0);
  };

  // get reward id
  const getRewardId = (blogId) => {
    const r = rewards.find((x) => x.blogId === blogId);
    return r?._id;
  };

  // ✅ pagination logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    fetchBlogs();
    fetchRewards();
  }, []);

  return (
    <div>

      <Navbar />

      <div className="admin-reward-container">

        <h1>Reward Management</h1>

        <table className="admin-table">

          <thead>
            <tr>
              <th>Title</th>
              <th>Author</th>
              <th>Date</th>
              <th>Likes</th>
              <th>Total Reward</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            {currentBlogs.map((blog) => {

              const rewardId = getRewardId(blog._id);

              return (
                <tr key={blog._id}>

                  <td>{blog.title}</td>

                  <td>{blog.author}</td>

                  <td>
                    {new Date(blog.createdAt).toLocaleDateString()}
                  </td>

                  <td>
                    {blog.likes ? blog.likes.length : 0}
                  </td>

                  <td>
                    ₹{getBlogReward(blog._id)}
                  </td>

                  <td>

                    <button
                      onClick={() => addReward(blog._id)}
                      style={{ background: "green", color: "#fff" }}
                    >
                      Reward
                    </button>

                    {rewardId && (
                      <button
                        onClick={() => deleteReward(rewardId)}
                        style={{
                          background: "red",
                          color: "#fff",
                          marginLeft: "5px",
                        }}
                      >
                        Delete
                      </button>
                    )}

                  </td>

                </tr>
              );

            })}

          </tbody>

        </table>

        {/* ✅ Pagination UI */}
        <div className="pagination">

          <button onClick={prevPage} disabled={currentPage === 1}>
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#333" : "#ddd",
                color: currentPage === i + 1 ? "#fff" : "#000",
                margin: "0 5px",
              }}
            >
              {i + 1}
            </button>
          ))}

          <button onClick={nextPage} disabled={currentPage === totalPages}>
            Next
          </button>

        </div>

      </div>

    </div>
  );
}

export default AdminRewardPage;